import { HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NotificationService } from './services/notification.service';

@Injectable()
export class ListBase {
    loading = false;

    constructor(@Inject(NotificationService) protected notificationService: NotificationService | null = null) {}

    public displayGridHidden(list: any) {
        let hasRows = false;

        if (list) {
            hasRows = list.length;
        }

        return {
            '': hasRows,
            'ocultar-grid': !hasRows,
        };
    }

    addErrorMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addErrorMessage(msg);
    }

    addInfoMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addInfoMessage(msg);
    }

    addWarningMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addWarningMessage(msg);
    }

    addSuccessMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addSuccessMessage(msg);
    }

    OpenDownloadedFile(res: HttpResponse<Blob>) {
        if (!res) {
            throw new Error('No existe Fichero');
        }
        let fileURL = URL.createObjectURL(res!.body!);
        let link = document.createElement('a');

        link.href = fileURL;
        link.download = res!.headers!.get('content-disposition')!.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');

        link.click();
        this.addSuccessMessage('Archivo descargado correctamente');
    }
}
